type SanitizeOptions = {
  maxArrayLength?: number
  maxStringLength?: number
  removeKeys?: string[]
}

const DEFAULT_OPTIONS: Required<SanitizeOptions> = {
  maxArrayLength: 100,
  maxStringLength: 3000,
  removeKeys: [
    'documentData',
    'base64',
    'fileContent',
    'binary',
    'blob',
    'contentBase64',
    'imageData',
    'pdfData',
    'rawFile'
  ]
}

export const sanitizeForInsights = <T>(
  input: T,
  options: SanitizeOptions = {}
): { data: unknown } => {
  const config = { ...DEFAULT_OPTIONS, ...options }

  const walk = (value: unknown, path: string, depth: number): unknown => {
    if (value === null || value === undefined) {
      return value
    }

    if (typeof value === 'string') {
      if (value.length > config.maxStringLength) {
        return value.slice(0, config.maxStringLength) + '...[TRUNCATED]'
      }

      return value
    }

    if (typeof value !== 'object') {
      return value
    }

    if (Array.isArray(value)) {
      const items = value
        .slice(0, config.maxArrayLength)
        .map((item, index) => walk(item, `${path}[${index}]`, depth + 1))

      return items
    }

    const obj = value as Record<string, unknown>
    const result: Record<string, unknown> = {}

    for (const [key, val] of Object.entries(obj)) {
      const nextPath = path ? `${path}.${key}` : key

      const keyLower = key.toLowerCase()
      const shouldRemove = config.removeKeys.some((k) => keyLower.includes(k.toLowerCase()))

      if (shouldRemove) {
        result[key] = '[REMOVED_FOR_SECURITY]'
        continue
      }

      result[key] = walk(val, nextPath, depth + 1)
    }

    return result
  }

  const data = walk(input, '', 0)

  return {
    data
  }
}
